import { Project } from './types';

export const COLORS = {
  background: '#121212',
  surface: '#1A1A1A',
  neonGreen: '#39FF14',
  neonGreenMuted: 'rgba(57, 255, 20, 0.2)',
};

export const PROJECTS: Project[] = [
  {
    id: '1',
    title: 'Reformas Quintans',
    category: 'Reformas & Construcción',
    description: 'Sitio corporativo de alto impacto para servicios de reformas integrales y pintura profesional. Proyecto de desarrollo web realizado para empresa de reformas, optimizado para el mercado local de Sevilla.',
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&q=80&w=1200',
    tech: ['React', 'Tailwind', 'Netlify'],
    size: 'large',
    url: 'https://reformasquintans.netlify.app'
  },
  {
    id: '2',
    title: 'Centro Estética',
    category: 'Salud & Belleza',
    description: 'Plataforma minimalista y elegante para la gestión de servicios de estética y bienestar. Proyecto de diseño web realizado para centro de estética, optimizado para el mercado local.',
    image: 'https://images.unsplash.com/photo-1560750588-73207b1ef5b8?auto=format&fit=crop&q=80&w=1200',
    tech: ['HTML5', 'CSS3', 'JS'],
    size: 'medium',
    url: 'https://centroesteticaprueba.netlify.app'
  },
  {
    id: '3',
    title: 'Arpasur',
    category: 'Corporativo & Logística',
    description: 'Presencia digital para servicios industriales y soluciones empresariales personalizadas. Proyecto de arquitectura web realizado para sector logístico e industrial, optimizado para el mercado local en Sevilla.',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=1200',
    tech: ['Next.js', 'Framer Motion'],
    size: 'large',
    url: 'https://arpasur.netlify.app'
  },
  {
    id: '4',
    title: 'Aura Tech Beauty',
    category: 'Estética Avanzada & Tech',
    description: 'Plataforma de vanguardia para servicios de estética avanzada, integrando tecnología láser, aparatología de última generación y bienestar. Diseño orientado a la conversión y experiencia de usuario premium.',
    image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?auto=format&fit=crop&q=80&w=1200',
    tech: ['React', 'Framer Motion', 'Tailwind'],
    size: 'medium',
    url: 'https://auratechbeauty.netlify.app'
  }
];

export const TECH_CATEGORIES = [
  {
    name: "Core Architecture",
    items: [
      { name: "React / Next.js", level: 95 },
      { name: "TypeScript", level: 90 },
      { name: "Tailwind CSS", level: 98 },
      { name: "Framer Motion", level: 85 },
      { name: "Three.js", level: 70 }
    ]
  },
  {
    name: "Backend & Logic",
    items: [
      { name: "Node.js", level: 88 },
      { name: "PostgreSQL / Prisma", level: 82 },
      { name: "GraphQL / REST", level: 90 },
      { name: "Serverless Functions", level: 85 }
    ]
  },
  {
    name: "DevOps & Tools",
    items: [
      { name: "Git / GitHub", level: 92 },
      { name: "Docker", level: 65 },
      { name: "Vercel / Netlify", level: 95 },
      { name: "SEO Optimization", level: 90 }
    ]
  }
];

export const TECH_STACK = [
  'React', 'Next.js', 'TypeScript', 'Node.js', 'Tailwind CSS', 'Framer Motion', 'GraphQL', 'Three.js'
];